import React, { useEffect, useState } from 'react'
import Spinwheel from '../../components/common/Spinwheel';
import toast from 'react-hot-toast';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useUserContext } from '../../context/userContext';
import { addInventoryItemApi, deleteInventoryItemByIdApi, getInventoryApi, updateInventoryItemApi } from '../../utils/ApiEndpointFunctions';
import ReactPaginate from 'react-paginate';
import { debounce } from 'lodash';
import { S3_URL } from '../../utils/BaseUrl';
import InventoryItemModal from '../../components/modal/inventoryItemModal';
import { useFormik } from 'formik';
import { inventoryItemInitialValue, inventoryItemValidationSchema } from '../../utils/Validation';
import StatusModal from '../../components/modal/StatusModal';
import ConfirmationModal from '../../components/modal/ConfirmationModal';

function ViewInventory(props) {
  const [inventory, setInventory] = useState([])
  const [loading, setLoading] = useState(true)
  const [totalCount, setTotalCount] = useState(null);
  const [page, setPage] = useState(0);
  // let [selectedPage, setSelectedPage] = useState(1);
  const navigate = useNavigate();
  const { userDetails,langPreference } = useUserContext();
  const limit = 10;
  const [search, setSearch] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const stockFilter = searchParams.get("stockStatus") || "all"
  const inventoryItemModalId = "inventoryItemModalId"
  const confirmModalId = "conFirmModalID"
  const statusModalId = "statusModal"
  const [disableItem,setDisableItem] = useState(false)
  const [selectItem,setSelectItem] = useState({name:"",_id:""})


  const handleChange = async (event) => {

    let search1 = event.target.value;
    setSearchParams({ page: 1, ...(stockFilter !== "all" ? { stockStatus: stockFilter } : {}) })
    setSearch(search1);
    setLoading(true);
    const res = await getInventoryApi(event.target.value, limit, 1, stockFilter === "all" ? "" : stockFilter);
    if (res.status === 200) {
      const totalData = res.data?.data?.totalData
      setTotalCount(totalData);
      setPage(Math.ceil(totalData / limit));
      setInventory(res.data?.data?.data);

      // setSelectedPage(1);
    }
    setLoading(false);
  };

  const debouncedOnChange = debounce(handleChange, 800);

  const getInventoryDetails = async () => {
    setLoading(true);
    try {
      const page = searchParams.get("page") || 1
      const res = await getInventoryApi(search, limit, page, stockFilter === "all" ? "" : stockFilter);
      if (res.status === 200) {
        const totalData = res.data?.data?.totalData
        setTotalCount(totalData);
        setPage(Math.ceil(totalData / limit));
        setInventory(res.data?.data?.data);
      }
    } catch (error) {
      console.log(error)
    }
    setLoading(false);
  }


  const handlePageClick = (event) => {
    let currentPage = event.selected + 1;
    setSearchParams({ page: currentPage, ...(stockFilter !== "all" ? { stockStatus: stockFilter } : {}) })
    // selectedPage = currentPage;
    // getInventoryDetails();
    // setSelectedPage(currentPage)
  };

  const handleStockFilter = (status) => {
    setSearchParams({ page: 1, ...(status !== "all" ? { stockStatus: status } : {}) })
  }

  const getStockHealth = (item) => {
    const available = Number(item?.availableQty || 0)
    const minimum = Number(item?.minQty || 0)

    if (available <= 0) return minimum > 0 ? "out" : "neutral"
    if (minimum > 0 && available < minimum) return "low"
    if (minimum > 0 && available <= minimum * 1.25) return "warning"
    return "healthy"
  }

  const handleInventoryItem =async(values)=>{
    setDisableItem(true);
    try {
      let payload ={...values}
      payload.name = values?.name?.name
      let isNew = !values?._id
      const res = isNew ? await addInventoryItemApi(payload) : await updateInventoryItemApi(payload);
      if (res.status === 200) {
        getInventoryDetails()
        toast.success(res?.data?.message)
        document.getElementById(inventoryItemModalId).click()
      }
    } catch (error) {
      console.log(error)
      toast.error(error?.response?.data?.message || "Failed to update")
    }
    setDisableItem(false);
  }

  const inventoryFormik = useFormik({
    initialValues: inventoryItemInitialValue,
    validationSchema:inventoryItemValidationSchema(langPreference),
    onSubmit:handleInventoryItem
  })


  useEffect(() => {
    getInventoryDetails()
  }, [searchParams.get('page'), searchParams.get('stockStatus')])

 const handleRemoveItem =async()=>{
  const _id = selectItem?._id
  if(_id){
    setDisableItem(true);
    try {
      const res =  await deleteInventoryItemByIdApi(_id);
      if (res.status === 200) {
        getInventoryDetails()
        toast.success(res?.data?.message)
        document.getElementById(confirmModalId).click()
        document.getElementById("statusModalBtn").click()
      }
    } catch (error) {
      console.log(error)
      toast.error(error?.response?.data?.message || "Failed to remove")
    }
    setDisableItem(false);
  }
 }

  return (
    <>
      <div className="main-content">
        <div className="container-fluid">
          <div className="row">
            <div className="main-content">
              {props.type !== "dashboard" && <div className="inventory-setup-header">
                <div className="inventory-setup-header__title-row">
                  <h3 className="mb-0 font-blue">{langPreference?.inventory_setup || "Inventory Setup"}</h3>
                  <div className="inventory-setup-header__actions">
                    {userDetails?.roleId?.permission?.includes("inventoryWrite") && <button className="btn btn-primary" type="button" data-bs-toggle="modal" onClick={inventoryFormik.resetForm} data-bs-target={`#${inventoryItemModalId}`}>
                      <i className="bi bi-plus-lg me-2"></i>{langPreference?.add || "Add"}
                    </button>}
                    {userDetails?.roleId?.permission?.includes("inventoryRead") && <button className="btn inventory-setup-header__report" type="button" onClick={() => navigate('/inventory/report')}>
                      <i className="bi bi-file-earmark-bar-graph me-2"></i>{langPreference?.report || "Report"}
                    </button>}
                  </div>
                </div>
                <div className="inventory-setup-header__controls">
                  <div className="input-group inventory-setup-search">
                    <span className="input-group-text"><i className="bi bi-search"></i></span>
                    <input type="search" className="form-control" placeholder={`${langPreference?.search_inventory || "Search inventory"}`} aria-label={langPreference?.search_inventory || "Search inventory"} onChange={debouncedOnChange} />
                  </div>
                  <div className="inventory-stock-filters" aria-label="Stock status filters">
                    <button type="button" className={stockFilter === "all" ? "active" : ""} onClick={() => handleStockFilter("all")}>{langPreference?.all || "All"}</button>
                    <button type="button" className={stockFilter === "low" ? "active" : ""} onClick={() => handleStockFilter("low")}>{langPreference?.low_stock || "Low Stock"}</button>
                    <button type="button" className={stockFilter === "out" ? "active" : ""} onClick={() => handleStockFilter("out")}>{langPreference?.out_of_stock || "Out of Stock"}</button>
                  </div>
                  <span className="inventory-result-count">{Number(totalCount || 0).toLocaleString("en-IN")} {langPreference?.items || "items"}</span>
                </div>
              </div>}
              <div className="table-responsive inventory-setup-table-wrap">
              <table className="table inventory-setup-table mb-0">
                <thead>
                  <tr>
                    <th scope="col-1">{langPreference?.name || "NAME"}</th>
                    <th scope="col-1">{langPreference?.hsn_code || "HSN CODE"}</th>
                    <th scope="col-1">{langPreference?.unit || "UNIT"}</th>
                    {/* <th scope="col-1">TAX(%)</th> */}
                    <th scope="col-1">{langPreference?.asset_type || "Asset Type"}</th>
                    <th scope="col-1">{langPreference?.track || "Track"}</th>
                    <th scope="col-1" className="text-end">{langPreference?.available_quantity || "Available quantity"}</th>
                    <th scope="col-1" className="text-end">{langPreference?.minimum_quantity || "Minimum Qty"}</th>
                    <th scope="col-2">{langPreference?.action || "Action"}</th>
                  </tr>
                </thead>
                {
                  loading ?
                    <tbody >
                      <tr>
                        <td colSpan={12}>
                          <div className="d-flex justify-content-center">
                            <Spinwheel />
                          </div>
                        </td>
                      </tr>
                    </tbody> :
                    <>
                      <tbody>

                        {inventory?.length > 0 ? inventory?.map((ele, index) => {
                          return (
                            <tr key={index}>
                              <td>{ele?.name}</td>
                              <td>{ele?.hsnCode}</td>
                              <td>{ele?.unitType}</td>
                              <td className="text-capitalize">{ele?.itemType || "-"}</td>
                              <td><span className={`inventory-track-status inventory-track-status--${ele?.isTrack ? "yes" : "no"}`}>{ele?.isTrack ? (langPreference?.yes || "Yes") : (langPreference?.no || "No")}</span></td>
                              {/* <td>{ele?.tax}</td> */}
                              <td className="text-end"><span className={`inventory-stock-quantity inventory-stock-quantity--${getStockHealth(ele)}`}>{Number(ele?.availableQty || 0).toLocaleString("en-IN")}</span></td>
                              <td className="text-end inventory-minimum-quantity">{Number(ele?.minQty || 0).toLocaleString("en-IN")}</td>
                              <td>
                                <div>
                                  <div className="dropdown">
                                    <button className="dots dropdown-toggle" type="button" data-bs-toggle="dropdown" data-bs-display="static" aria-expanded="false"><i className="bi bi-three-dots-vertical"></i></button>
                                    <ul className="dropdown-menu dropdown-menu-end">
                                      {<li className='dropdown-item' data-bs-toggle="modal" onClick={() => inventoryFormik.setValues({ ...ele, addedQty: 0 })} data-bs-target={`#${inventoryItemModalId}`}>{langPreference?.edit || "Edit"}</li>}
                                      {/* {userDetails?.roleId?.permission.includes("inventoryRead") &&  <li className='dropdown-item' onClick={()=>navigate(`/inventory/report/${ele?._id}`)}>View Report</li>} */}
                                      {userDetails?.roleId?.permission.includes("inventoryDelete") &&  <li className='dropdown-item' data-bs-toggle="modal" onClick={() => setSelectItem({name:ele?.name, _id:ele?._id })} data-bs-target={`#${confirmModalId}`}>{langPreference?.remove || "Delete"}</li>}
                                    </ul>
                                  </div>
                                </div>
                              </td>
                            </tr>)
                        }) : <tr className='text-center'>
                          <td colSpan="12">
                            <div className="inventory-setup-empty">{langPreference?.data_not_found || "Data Not Found"}</div>
                          </td>
                        </tr>}
                      </tbody></>}
              </table>
              </div>

            </div>
          </div>

          {totalCount > limit ? (
            <div className="d-flex justify-content-center inventory-setup-pagination">
              <ReactPaginate
                nextLabel={`${langPreference?.next_page || "Next"}>`}
                onPageChange={handlePageClick}
                pageRangeDisplayed={3}
                marginPagesDisplayed={1}
                pageCount={page}
                previousLabel={`< ${langPreference?.previous_page || "Previous"}`}
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                breakLabel="..."
                breakClassName="page-item"
                breakLinkClassName="page-link"
                containerClassName="pagination"
                activeClassName={"active"}
                forcePage={searchParams.get('page')? Number(searchParams.get('page'))-1 : 0}
              />
            </div>
          ) : (
            ""
          )}
        </div>
        <InventoryItemModal modalId={inventoryItemModalId} formik={inventoryFormik} disable={disableItem} />
        <ConfirmationModal modalId={confirmModalId} handleConfirm={handleRemoveItem} message={<>Are you sure you want to <br /> Remove ?</>} />
        <button className='d-none' id="statusModalBtn" data-bs-toggle="modal" data-bs-target={`#${statusModalId}`} />
        <StatusModal
          modalId={statusModalId}
          message={`${selectItem.name || ""} is successfully removed.`}
        />
      </div>
    
    </>
  )
}

export default ViewInventory
